import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const NewCalendarIcon: ComponentWithAs<'svg', IIconProps> = (
  props: any,
) => (
  <Icon
    data-testid="new-calendar-icon"
    boxSize={4}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.09388 1C4.41747 1 4.6798 1.27222 4.6798 1.60802V2.95996C6.88891 2.7558 9.11114 2.75581 11.3202 2.95996V1.60802C11.3202 1.27222 11.5826 1 11.9062 1C12.2298 1 12.4921 1.27222 12.4921 1.60802V3.0806C13.6585 3.25174 14.58 4.20911 14.736 5.43031L14.8036 5.95966C15.088 8.18609 15.0634 10.4433 14.7307 12.6625C14.5658 13.7619 13.7052 14.6063 12.6382 14.7154L11.7062 14.8108C9.24137 15.0631 6.75863 15.0631 4.29381 14.8108L3.3618 14.7154C2.29485 14.6063 1.4342 13.7619 1.26935 12.6625C0.936579 10.4433 0.912017 8.18609 1.19641 5.95966L1.26403 5.43031C1.42002 4.2091 2.34152 3.25171 3.50795 3.08059V1.60802C3.50795 1.27222 3.77028 1 4.09388 1ZM4.44165 4.20452C6.80814 3.96234 9.19186 3.96234 11.5583 4.20452L12.2657 4.27691C12.9428 4.3462 13.4849 4.89015 13.5743 5.59011L13.6419 6.11945C13.6655 6.30438 13.6869 6.48953 13.706 6.67486H2.29397C2.3131 6.48953 2.33447 6.30438 2.3581 6.11945L2.42571 5.59011C2.51512 4.89015 3.05716 4.3462 3.73429 4.27691L4.44165 4.20452ZM2.20083 7.8909C2.12412 9.42156 2.19969 10.9579 2.42726 12.4756C2.50995 13.027 2.94164 13.4505 3.47681 13.5053L4.40882 13.6006C6.79715 13.8451 9.20285 13.8451 11.5912 13.6006L12.5232 13.5053C13.0584 13.4505 13.4901 13.027 13.5727 12.4756C13.8003 10.9579 13.8759 9.42156 13.7992 7.8909H2.20083Z"
      fill="currentColor"
    />
  </Icon>
);
